import { Suspense, useEffect } from 'react';

import loadable from '@loadable/component';
import { Helmet } from 'react-helmet-async';
import { useHistory } from 'react-router';

import { updateModalState } from 'actions/rekycVerification';
import { HYPERVERGE_SDK_URL } from 'constants/constants';
import { useRouterSearchParams } from 'hooks/useRouterSearchParams';
import { selectIsRekycModalOpen } from 'selectors/rekycVerification';
import { useAppDispatch, useAppSelector } from 'storeHooks';

import { RekycDetailsModalLoader } from './RekycDetailsModalLoader';
import { OPEN_MODAL_QUERY_PARAM } from './rekycVerification.constants';

const AsyncRenderRekycDetailsModal = loadable(
  () =>
    import(
      /* webpackChunkName: "AsyncRenderRekycDetailsModal" */ './RenderRekycDetailsModal'
    )
);

const RekycDetailsVerification = () => {
  const isModalOpen = useAppSelector(selectIsRekycModalOpen);

  const appDispatch = useAppDispatch();

  const history = useHistory();

  const searchParams = useRouterSearchParams();

  useEffect(() => {
    if (searchParams.get(OPEN_MODAL_QUERY_PARAM) === 'true') {
      appDispatch(updateModalState({ value: true, source: 'url' }));

      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.delete(OPEN_MODAL_QUERY_PARAM);

      const newSearch = newSearchParams.toString();
      const newPath = `${history.location.pathname}${newSearch ? `?${newSearch}` : ''}`;

      history.replace(newPath);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appDispatch, searchParams]);

  if (!isModalOpen) return null;

  return (
    <>
      <Helmet>
        <script src={HYPERVERGE_SDK_URL} async />
      </Helmet>
      <Suspense fallback={<RekycDetailsModalLoader />}>
        <AsyncRenderRekycDetailsModal />
      </Suspense>
    </>
  );
};

export { RekycDetailsVerification };
